import type { UseMutationResult } from 'react-query';
import { useMutation, useQueryClient } from 'react-query';

import type { IApiDeleteLegalDocumentResponseBody } from '../LegalDocumentsApi.types';
import { useApi } from '~/lib/api/useApi';
import { legalDocumentQueryKeyFactory } from './useLegalDocumentQuery';
import { legalDocumentsQueryKeyFactory } from './useLegalDocumentsQuery';

export type IUseDeleteLegalDocumentMutationValues = {
  appId: string;
  legalDocumentId: string;
};

export const useDeleteLegalDocumentMutation = (): UseMutationResult<
  IApiDeleteLegalDocumentResponseBody,
  unknown,
  IUseDeleteLegalDocumentMutationValues
> => {
  const api = useApi();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (values: IUseDeleteLegalDocumentMutationValues) =>
      api.legalDocuments.delete(values.appId, values.legalDocumentId),
    onSuccess: async (data, values) => {
      data.deletedResources.legalDocumentIds
        .map((legalDocumentId) => [
          {
            queryKey: legalDocumentQueryKeyFactory({
              appId: values.appId,
              legalDocumentId,
            }),
          },
        ])
        .flat()
        .forEach((filters) => queryClient.removeQueries(filters));

      await queryClient.invalidateQueries({
        queryKey: legalDocumentsQueryKeyFactory({
          appId: values.appId,
        }),
      });
    },
  });
};
